import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Warranty',
    component: () => import('../pages/Warranty/Index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
